module.exports = __webpack_public_path__ + "img/sucot-2019.d09be288.jpeg";